import React from "react";
import { Dialog } from "primereact/dialog";

const ConfirmationDialog = ({ show, onConfirm, onCancel }) => {
  return (
    <div>
      <Dialog
        visible={show}
        style={{ width: "50vw" }}
        className="edit-contact-dialog"
        onHide={onCancel}
      >
        <p className="del-dialog-heading">Are you sure you want to leave?</p>

        <p className="del-dialog-para">
          If you leave now, your changes won't be saved. Would you like to
          continue without saving or go back to finish setting up?
        </p>
        <div className="flex justify-content-end gap-2 mt-4">
          <button className="cancel-btns" onClick={onCancel}>
            Cancel
          </button>
          <button className="confirm-btn" onClick={onConfirm}>
            Yes, leave
          </button>
        </div>
      </Dialog>
    </div>
  );
};

export default ConfirmationDialog;
